import * as gs from "@ivanlog/gs";
import * as com from "./tmpls";
import { App } from "../App";
import { ShareXInfrastructure } from "../contracts/ShareXInfrastructure";

export class CmpWidgetShareXSaved extends com.CmpWidgetShareXSavedBase {

    constructor() {
        super();

    }

    private _refreshFunc:any;
    public initialize()
    {
        const shareXCtrl = App.Inst.getInst(ShareXInfrastructure);
        if (shareXCtrl)
        {
            this._refreshFunc = async ()=>{this.refreshAsync()};
            shareXCtrl.onRefresh.addHandler(this._refreshFunc);
        }
        this.refreshAsync();
    }
    public dispose()
    {
        const shareXCtrl = App.Inst.getInst(ShareXInfrastructure);
        if (shareXCtrl)
        {
            shareXCtrl.onRefresh.removeHandler(this._refreshFunc);
        }
    }

    public async refreshAsync()
    {
        const shareXCtrl = App.Inst.getInst(ShareXInfrastructure);
        if (!shareXCtrl) return;
        const sharexs = shareXCtrl.getShareXs();
        this.ctrls.list.html='';

        for(const t of sharexs)
        {
            const adr = t.address.substring(0,14)+".."+t.address.substring(t.address.length-12,t.address.length);
            const item = gs.w(gs.html.span({}));
            item.text = t.name+":\n"+adr;
            if (shareXCtrl.selectedShareX&&t.address==shareXCtrl.selectedShareX.address)
                item.active();
            this.ctrls.list.append(item);
            item.onclick=()=>{
                shareXCtrl.selectShareX(t);
            }
        }
    }


}